import { render, staticRenderFns } from "./Gestionar.vue?vue&type=template&id=cb8feaea&"
import script from "./Gestionar.vue?vue&type=script&lang=js&"
export * from "./Gestionar.vue?vue&type=script&lang=js&"
import style0 from "./Gestionar.vue?vue&type=style&index=0&id=cb8feaea&prod&lang=scss&"
import style1 from "./Gestionar.vue?vue&type=style&index=1&id=cb8feaea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports